import React from 'react';
import { Router } from '@/modules/Router';
import useSessionRefresh from './modules/Auth/hooks/useSessionRefresh';

const App = () => {
  useSessionRefresh();

  return (
    <div className="App">
      <Router />
    </div>
  );
};

export default App;
